import { render } from "./SectionTiles.vue?vue&type=template&id=db726db4&scoped=true&ts=true"
import script from "./SectionTiles.vue?vue&type=script&lang=ts"
export * from "./SectionTiles.vue?vue&type=script&lang=ts"

import "./SectionTiles.vue?vue&type=style&index=0&id=db726db4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db726db4"]])

export default __exports__